import React from 'react';
import '../index.css';
import '../pubic/output.css';

import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonFab,
  IonFabButton,
  IonIcon,
  IonGrid,
  IonRow,
  IonCol,
  IonImg,
  IonActionSheet,
} from '@ionic/react';

import { checkmarkOutline } from 'ionicons/icons';
import { cashOutline } from 'ionicons/icons';
import { lockClosedOutline } from 'ionicons/icons';

import { useState, useEffect } from 'react';

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < breakpoint);
    checkMobile(); // Check on mount

    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, [breakpoint]);

  return isMobile;
}

export default function Features() {

  const isMobile = useIsMobile();

  if (isMobile) {
    return (
          <section className="BullsBarclayGradient p-10">
      <IonRow className="p-10 text-center">
      <div className="p-10" style={{backgroundColor:"rgba(200,200,200,0.2)", border:"2px solid rgba(250,250,250,0.3)", borderRadius: "30px",  backdropFilter:"blur(5px)", width: "100vw"}}>
      <IonIcon icon={checkmarkOutline} className="text-white" style={{ fontSize: "100px"}} />
      <h1 className="text-white text-center text-5xl font-bold" style={{ fontFamily: 'Helvetica, sans-serif' }}> <br /> Easy <br /> <br /></h1>
      </div>
      </IonRow>

      <IonRow className="p-10 text-center">
      <div className="p-10" style={{backgroundColor:"rgba(200,200,200,0.2)", border:"2px solid rgba(250,250,250,0.3)", borderRadius: "30px",  backdropFilter:"blur(5px)", width: "100vw"}}>
      <IonIcon icon={cashOutline} className="text-white" style={{ fontSize: "100px"}} />
      <h1 className="text-white text-center text-5xl font-bold" style={{ fontFamily: 'Helvetica, sans-serif' }}> <br /> Cheap <br /> <br /></h1>
      </div>
      </IonRow>
      <IonRow className="p-10 text-center">
<div className="p-10" style={{backgroundColor:"rgba(200,200,200,0.2)", border:"2px solid rgba(250,250,250,0.3)", borderRadius: "30px",  backdropFilter:"blur(5px)", width: "100vw"}}>
      <IonIcon icon={lockClosedOutline} className="text-white" style={{fontSize:"100px"}} />
      <h1 className="text-white text-center text-5xl font-bold" style={{ fontFamily: 'Helvetica, sans-serif' }}> <br /> Secure <br /> <br /></h1>
      </div>
      </IonRow>
      {/* </IonRow> */}
    </section>
    )
  } else {

  return (
    <section className="BullsBarclayGradient p-10">

    {/* <IonRow className="ion-align-items-stretch">

    <IonRow classname="p-10">
    */}

    {/*FUCK YOU TAILWIND!!*/}
       {/* <div className="p-10" style={{backgroundImage: "linear-gradient(to top right, rgba(237,74,221,0.4), rgba(255,155,82,0.4), rgba(235,229,110,0.4))", borderRadius: "30px",  backdropFilter: "blur(5px)", width: "100%"}}
      <div className="p-10 text-center" style={{backgroundColor:"rgba(200,200,200,0.2)", border:"2px solid rgba(250,250,250,0.3)", borderRadius: "30px",  backdropFilter:"blur(5px)", width: "100vw"}}>
      <IonIcon icon={checkmarkOutline} className="text-white" style={{ fontSize: "100px"}} />
      <h1 className="p-2 text-white text-center text-5xl font-bold" style={{ fontFamily: 'Helvetica, sans-serif' }}> <br /> Easy <br /> <br /></h1>
      <p className="text-white text-center"> Our open ticketing market is simple, fast, and efficient. No crashes, no drama, no bullshit. Join a queue, grab your tickets, and go have fun. That's it.</p>
      </div>
      </IonRow>
      */}

      <IonRow className="p-10 text-center">
      <div className="p-10" style={{backgroundColor:"rgba(200,200,200,0.2)", border:"2px solid rgba(250,250,250,0.3)", borderRadius: "30px",  backdropFilter:"blur(5px)", width: "100vw"}}>
      <IonIcon icon={checkmarkOutline} className="text-white" style={{ fontSize: "100px"}} />
      <h1 className="text-white text-center text-5xl font-bold" style={{ fontFamily: 'Helvetica, sans-serif' }}> <br /> Easy <br /> <br /></h1>
      <p className="text-white"> Decentix’s open marketplace for event tickets makes buying and selling tickets more efficient, cheaper, and with less hassle. See previous ticket sales trends to know that you are getting the best bang for your buck, with reassurance that our ticket for ticket swaps allow for you to trade tickets with others if you can’t make it or find a different event you like better. No more searching different platforms to secure tickets; every ticket you need will be on Decentix. No crashes, No frustration, No BS. </p>
      </div>
      </IonRow>

      <IonRow className="p-10 text-center">
      <div className="p-10" style={{backgroundColor:"rgba(200,200,200,0.2)", border:"2px solid rgba(250,250,250,0.3)", borderRadius: "30px",  backdropFilter:"blur(5px)", width: "100vw"}}>
      <IonIcon icon={cashOutline} className="text-white" style={{ fontSize: "100px"}} />
      <h1 className="text-white text-center text-5xl font-bold" style={{ fontFamily: 'Helvetica, sans-serif' }}> <br /> Cheap <br /> <br /></h1>
      <p className="text-white"> No fees. Simple as that. At Decentix, we want to make your favorite events not only more enjoyable, but also more affordable. On Decentix, you'll never pay a fee at retail (the first-time sale of a ticket). For artists, we're offering a new royalty system - one unrivaled by all of our competitors. To artists: it's time you finally got paid. To fans: let's cut the fees. People should go out and attend their favorite events, regardless of budget. With Decentix, feel free to show up to support your favorite artists and teams, whether you’re with 50,000 other people or just 50. Your wallet will thank you. </p>
      </div>
      </IonRow>
      <IonRow className="p-10 text-center">
<div className="p-10" style={{backgroundColor:"rgba(200,200,200,0.2)", border:"2px solid rgba(250,250,250,0.3)", borderRadius: "30px",  backdropFilter:"blur(5px)", width: "100vw"}}>
      <IonIcon icon={lockClosedOutline} className="text-white" style={{fontSize:"100px"}} />
      <h1 className="text-white text-center text-5xl font-bold" style={{ fontFamily: 'Helvetica, sans-serif' }}> <br /> Secure <br /> <br /></h1>
      <p className="text-white"> Your tickets are safe with us. That's the blockchain promise. With Ethereum, you have full custody over your tickets. No more scams, no more angry customer support calls. We're also out to kill the Ticketmaster trasnfer portal. With blockchain, delivery and transfer of tickets is fully automatic. Buy, sell, bid, auction, and trade/swap event tickets safely with 0 hassle. Your tickets are yours and we keep it that way.</p>
      </div>
      </IonRow>
      {/* </IonRow> */}
    </section>
  );
}
}
